// Dicionário de traduções — Português (idioma base)
const pt = {
  comum: {
    salvar: 'Salvar',
    cancelar: 'Cancelar',
    excluir: 'Excluir',
    deletar: 'Deletar',
    editar: 'Editar',
    fechar: 'Fechar',
    voltar: 'Voltar',
    confirmar: 'Confirmar',
    carregando: 'Carregando...',
    salvando: 'Salvando...',
    enviando: 'Enviando...',
    processando: 'Processando...',
    atualizar: 'Atualizar',
    buscar: 'Buscar',
    sim: 'Sim',
    nao: 'Não',
    ok: 'OK',
    erro_generico: 'Ocorreu um erro. Tente novamente.',
    nenhum_resultado: 'Nenhum resultado encontrado',
    obrigatorio: 'Campo obrigatório',
    opcional: 'opcional',
  },

  nav: {
    principal: 'Principal',
    dashboard: 'Dashboard',
    campanhas: 'Campanhas',
    contatos: 'Contatos',
    envios: 'Envios',
    metricas: 'Métricas',
    whatsapp: 'WhatsApp',
    configuracoes: 'Configurações',
    minha_empresa: 'Minha empresa',
    creditos: 'Créditos',
    pacotes: 'Pacotes',
    upgrade_plano: 'Fazer upgrade',
    pack_ia: 'Pack IA avulso',
    ia_beta: 'IA (Beta)',
    secretaria_ia: 'Concierge IA',
    conversas: 'Conversas',
    configurar_ia: 'Configurar IA',
    ia_requer_plano: 'Requer plano Pro ou Pack IA. Clique para ver os pacotes.',
    administracao: 'Administração',
    painel_admin: 'Painel Admin',
    sair: 'Sair',
    painel: 'Painel',
    abrir_menu: 'Abrir menu',
    fechar_menu: 'Fechar menu',
    idioma: 'Idioma',
  },

  login: {
    marca_sub: 'Sua concierge no WhatsApp',
    nav_vantagens: 'Vantagens',
    nav_planos: 'Planos',
    nav_entrar: 'Entrar',
    hero_badge: 'Concierge IA que atende seu WhatsApp 24h — sem férias, sem ban',
    hero_titulo_1: 'O paciente chega às 22h, no domingo, no feriado.',
    hero_titulo_destaque: 'Sua Concierge IA responde na hora',
    hero_sub: 'Cada paciente que espera resposta agenda na clínica do lado. A Concierge IA da RIIA atende, tira dúvidas, entende o caso e agenda direto na sua agenda pelo WhatsApp — e ainda lembra antes da consulta e traz de volta quem sumiu. Você só entra quando a venda está pronta.',
    hero_cta_gratis: 'Começar grátis',
    hero_cta_planos: 'Ver planos',
    stat_entrega: 'Taxa de entrega',
    stat_respostas: 'Mais respostas',
    stat_negocios: 'Negócios atendidos',
    stat_gratis: 'Grátis para testar',
    stat_gratis_valor: '7 dias',
    stat_freemium: 'Plano Freemium grátis',
    stat_freemium_valor: 'Grátis',
    form_titulo: 'Entrar no painel',
    form_sub: 'Acesse sua conta RIIA',
    form_ja_cliente: 'Já é cliente? Entre com seu email e senha.',
    form_email: 'Email',
    form_senha: 'Senha',
    form_mostrar_senha: 'Mostrar senha',
    form_ocultar_senha: 'Ocultar senha',
    form_entrando: 'Entrando...',
    form_entrar: 'Entrar',
    form_sem_conta: 'Ainda não tem conta?',
    form_ver_planos: 'Veja os planos',
    form_esqueci_senha: 'Esqueci minha senha',
    recuperar_titulo: 'Recuperar senha',
    recuperar_descricao: 'Informe o email da sua conta. Enviaremos um link para você redefinir sua senha.',
    recuperar_enviar: 'Enviar link de recuperação',
    recuperar_enviando: 'Enviando...',
    recuperar_sucesso: 'Se o email estiver cadastrado, você receberá um link de redefinição em instantes.',
    recuperar_erro: 'Erro ao solicitar recuperação',
    erro_credenciais: 'Email ou senha inválidos',
    erro_conexao: 'Sem conexão com o servidor. Verifique sua internet.',
    erro_servidor: 'Servidor indisponível. Tente novamente em instantes.',
    erro_generico: 'Erro {status} ao entrar',
    vantagens_titulo: 'Uma concierge que não dorme, não esquece e não custa salário',
    vantagens_sub: 'Uma recepcionista humana custa R$ 2.000+/mês e atende 8h por dia. A Concierge IA trabalha 24h, todos os dias, sem férias nem rescisão.',
    vantagens: {
      secretaria_titulo: 'Concierge IA 24/7',
      secretaria_texto: 'Responde cada paciente em segundos, a qualquer hora. Tira dúvidas, entende o caso pelo funil do seu negócio, agenda e avisa sua equipe quando o paciente está pronto para fechar.',
      ia_titulo: 'IA que humaniza',
      ia_texto: 'Cada mensagem é reescrita por IA para soar natural e variar entre contatos — reduz risco de bloqueio.',
      pacing_titulo: 'Pacing humano',
      pacing_texto: 'Intervalos aleatórios entre mensagens e pausas em blocos. O envio respeita o ritmo de uma pessoa real.',
      janela_titulo: 'Janela de horário',
      janela_texto: 'Defina horário comercial para envio. Pausa automática à noite e retoma do ponto onde parou no dia seguinte.',
      canais_titulo: 'WhatsApp + Email',
      canais_texto: 'Mesmo painel, dois canais. Crie campanhas multimídia (texto, imagem, vídeo, áudio, documento).',
      tempo_real_titulo: 'Acompanhe em tempo real',
      tempo_real_texto: 'Dashboard de status, envios entregues, falhas e progresso de cada campanha — atualizado a cada 15s.',
      import_titulo: 'Importação fácil',
      import_texto: 'Suba sua base via CSV ou sincronize direto do WhatsApp conectado. Grupos automáticos por tamanho.',
    },
    planos_titulo: 'Planos simples, sem letras miúdas',
    planos_sub: 'Comece grátis. Faça upgrade quando precisar. Cancele quando quiser.',
    plano_popular: 'Mais popular',
    plano_gratis: 'Grátis',
    plano_para_sempre: 'para sempre',
    plano_sob_consulta: 'Sob consulta',
    plano_personalizado: 'plano personalizado',
    planos: {
      freemium_descricao: 'Para conhecer a plataforma',
      freemium_cta: 'Criar conta grátis',
      freemium_recursos: [
        '1 instância de WhatsApp',
        '50 contatos',
        '100 disparos/mês',
        'Sem Concierge IA',
        'Suporte por email',
      ],
      starter_descricao: 'Para pequenos negócios',
      starter_cta: 'Assinar Starter',
      starter_recursos: [
        '1 instância de WhatsApp',
        '1.000 contatos',
        '3.000 disparos/mês',
        'IA para variações de mensagem',
        'Créditos avulsos disponíveis',
        'Suporte por email',
      ],
      essencial_descricao: 'Para negócios em crescimento',
      essencial_cta: 'Assinar Essencial',
      essencial_recursos: [
        '2 instâncias de WhatsApp',
        '2.000 contatos',
        '4.000 disparos/mês',
        'Concierge IA — 150 msgs/mês',
        'Créditos avulsos disponíveis',
        'Suporte por email',
      ],
      pro_descricao: 'Disparo + Concierge IA 24h',
      pro_cta: 'Assinar Profissional',
      pro_recursos: [
        '3 instâncias de WhatsApp',
        '3.000 contatos',
        '5.000 disparos/mês',
        'Concierge IA — 500 msgs/mês',
        'Créditos avulsos disponíveis',
        'Suporte prioritário',
      ],
      enterprise_descricao: 'Para grandes operações',
      enterprise_cta: 'Falar com vendas',
      enterprise_recursos: [
        'Instâncias e volumes sob demanda',
        'Concierge IA com cota ampliada',
        'Múltiplos usuários e equipes',
        'Onboarding dedicado + SLA',
        'Gerente de conta exclusivo',
      ],
    },
    planos_rodape: '🔒 Pagamento seguro via Stripe · Cancele a qualquer momento · Sem fidelidade',
    cta_titulo: 'Quantos pacientes você vai perder esta semana?',
    cta_sub: 'Ative sua Concierge IA hoje e responda cada cliente em segundos. Comece grátis, sem cartão.',
    cta_gratis: 'Começar grátis',
    cta_vendas: 'Falar com vendas',
    footer_direitos: '© {ano} RIIA · Todos os direitos reservados',
    footer_site: 'Site oficial',
    footer_suporte: 'Suporte',
    footer_assinar: 'Assinar',
    whatsapp_vendas_msg: 'Olá! Quero saber mais sobre a RIIA.',
  },

  dashboard: {
    titulo: 'Dashboard',
    atualizado_as: 'Atualizado às {hora}',
    atualizar: 'Atualizar',
    card_total: 'Total de campanhas',
    card_finalizadas: 'Finalizadas',
    card_andamento: 'Em andamento',
    card_contatos: 'Contatos ativos',
    ultimas_campanhas: 'Últimas campanhas',
    status_campanhas: 'Status das campanhas',
    pie_finalizadas: 'Finalizadas',
    pie_andamento: 'Em andamento',
    pie_erros: 'Erros',
    bar_finalizada: 'Finalizada',
    nenhuma_campanha: 'Nenhuma campanha ainda',
  },

  fluxo: {
    titulo: 'Como começar',
    etapas_concluidas: '{feitas} de {total} etapas concluídas',
    trilha_concierge: 'SUA CONCIERGE — atende, agenda e acompanha',
    trilha_campanhas: 'CAMPANHAS — avisos e promoções em massa',
    c1_label: 'Ligar a concierge',
    c1_desc: 'Ative o atendimento automático no WhatsApp',
    c2_label: 'Dizer quem ela é',
    c2_desc: 'Nome, negócio e como ela deve atender',
    c3_label: 'Conectar a agenda',
    c3_desc: 'Para ela marcar horário de verdade no seu sistema',
    c4_label: 'Perfil de atendimento',
    c4_desc: 'Tom de voz, emoji e forma de tratamento',
    c5_label: 'Ajustar as antecedências',
    c5_desc: 'Escolher quando avisar — o padrão já avisa 1 dia e 2h antes',
    c6_label: 'Acompanhar depois',
    c6_desc: 'Pós-atendimento, reativação ou lista de espera',
    fechar_guia: 'Fechar guia',
    fechar: 'Fechar',
    step1_label: 'Conectar WhatsApp',
    step1_desc: 'Escaneie o QR Code para conectar seu número',
    step2_label: 'Sincronizar contatos',
    step2_desc: 'Importe os contatos da sua conta WhatsApp',
    step3_label: 'Criar grupos',
    step3_desc: 'Organize contatos por segmento ou campanha',
    step4_label: 'Criar campanha',
    step4_desc: 'Configure mensagem, intervalos e destinatários',
    step5_label: 'Iniciar disparo',
    step5_desc: 'Ative o envio e acompanhe o progresso',
    opcional: 'opcional',
    concluido: '✓ Concluído',
    fazer_agora: '→ Fazer agora',
    pendente: 'Pendente',
    tudo_pronto: '🎉 Tudo configurado! Seu sistema está pronto para disparar campanhas.',
  },

  whatsapp: {
    titulo: 'WhatsApp',
    subtitulo: 'Gerencie suas instâncias e conecte números via QR Code.',
    atualizar_status: 'Atualizar status',
    plano_info: '📱 Plano {plano} — {usadas} de {limite} instância(s) usadas',
    limite_atingido_sufixo: ' · Limite atingido',
    fazer_upgrade: '⬆️ Fazer upgrade',
    upgrade_msg: 'Olá! Quero fazer upgrade do meu plano RIIA para conectar mais instâncias de WhatsApp.',
    guia_titulo: '📋 Como conectar seu WhatsApp:',
    guia_desktop: 'Desktop/notebook:',
    guia_desktop_texto: ' clique em QR Code, abra o WhatsApp no celular → Aparelhos conectados → Conectar aparelho → escaneie.',
    guia_celular: 'Celular/tablet:',
    guia_celular_texto: ' abra esta página no computador, gere o QR, clique em 📥 Baixar QR Code, envie a imagem para si mesmo (email ou WhatsApp) e escaneie a partir de outro dispositivo.',
    nova_instancia: 'Nova instância',
    nova_instancia_placeholder: 'Ex: chip-vendas-01',
    criando: 'Criando...',
    criar: 'Criar',
    limite_aviso: '⚠️ Limite de instâncias atingido. Faça upgrade do plano para conectar mais números.',
    qr_titulo: 'Escaneie o QR Code — {nome}',
    qr_passos: 'WhatsApp → Aparelhos conectados → Conectar aparelho',
    qr_celular: '📱 Está no celular? Baixe o QR e abra em outro aparelho para escanear.',
    qr_baixar: '📥 Baixar QR Code',
    qr_indisponivel: 'QR Code não disponível — aguarde ou tente novamente',
    qr_auto_atualiza: 'Atualiza automaticamente a cada 20s',
    fechar: 'Fechar',
    col_instancia: 'Instância',
    col_status: 'Status',
    col_acoes: 'Ações',
    status_conectado: 'Conectado',
    status_conectando: 'Conectando...',
    status_desconectado: 'Desconectado',
    status_nao_encontrada: 'Não encontrada',
    status_desconhecido: 'Desconhecido',
    btn_qrcode: '📷 QR Code',
    btn_sincronizar: 'Sincronizar contatos',
    btn_desconectar: 'Desconectar',
    btn_deletar: 'Deletar',
    vazio: 'Nenhuma instância criada ainda',
    toast_nome_obrigatorio: 'Nome é obrigatório',
    toast_criada: 'Instância criada!',
    toast_erro_criar: 'Erro ao criar instância',
    toast_erro_qr: 'Erro ao buscar QR Code',
    toast_conectado: 'WhatsApp conectado! 🎉',
    confirm_desconectar: 'Desconectar "{nome}"?',
    toast_desconectada: 'Instância desconectada',
    toast_erro_desconectar: 'Erro ao desconectar',
    confirm_deletar: 'Deletar instância "{nome}"?',
    toast_deletada: 'Instância deletada',
    toast_erro_deletar: 'Erro ao deletar',
    toast_sincronizando: 'Sincronizando contatos...',
    toast_sincronizados: '{n} contatos sincronizados!',
    toast_erro_sincronizar: 'Erro ao sincronizar contatos',
    popup_qr_titulo: 'Instância criada! 🎉',
    popup_qr_texto: 'Agora conecte seu WhatsApp escaneando o QR Code. Esse é o próximo passo para começar a usar a instância "{nome}".',
    popup_qr_botao: '📷 Conectar via QR Code',
    popup_qr_depois: 'Depois',
    popup_sync_titulo: 'WhatsApp conectado! ✅',
    popup_sync_texto: 'Para começar a enviar mensagens, sincronize seus contatos do WhatsApp agora. Você poderá refazer isso a qualquer momento.',
    popup_sync_botao: 'Sincronizar contatos',
    popup_sync_depois: 'Sincronizar depois',
  },

  nova_campanha: {
    titulo: 'Nova campanha',
    subtitulo: 'Configure mensagem, intervalos e contatos antes de iniciar o envio.',
    step_configurar: 'Configurar campanha',
    step_contatos: 'Selecionar contatos',
    nome_campanha_label: 'Nome da campanha',
    nome_campanha_placeholder: 'Ex: Promoção de abril',
    tipo_envio_label: 'Tipo de envio',
    tipo_whatsapp: '📲 WhatsApp',
    tipo_email: '📧 Email',
    addon_email_hint: '💡 Quer disparar por email também? Contrate o addon por +R$10/mês nas Configurações.',
    instancia_label: 'Instância WhatsApp',
    instancia_placeholder: 'disparador01',
    instancia_nenhuma: 'Nenhuma instância cadastrada.',
    instancia_criar_link: 'Crie uma aqui',
    midia_checkbox: '📎 Incluir mídia (criativo)',
    midia_tipo_label: 'Tipo de mídia',
    midia_tipo_image: '🖼️ Imagem',
    midia_tipo_video: '🎥 Vídeo',
    midia_tipo_audio: '🎵 Áudio',
    midia_tipo_document: '📄 Documento',
    midia_origem_upload: '📁 Arquivo local',
    midia_origem_url: '🔗 URL externa',
    midia_upload_enviando: '⏳ Enviando...',
    midia_upload_enviado: '✅ {nome}',
    midia_upload_cta: '📁 Clique para selecionar arquivo',
    canva_divider: 'ou crie no',
    canva_cta: 'Criar imagem no Canva',
    canva_aguardando: 'Aguardando design no Canva...',
    canva_passos_1: 'Crie ou edite seu design no Canva',
    canva_passos_2: 'Clique em Compartilhar → Baixar (PNG ou JPG)',
    canva_passos_3: 'Volte aqui e selecione o arquivo baixado',
    canva_ja_baixei: 'Já baixei — selecionar arquivo',
    canva_cancelar: 'Cancelar',
    chatgpt_cta_imagem: 'Criar imagem no ChatGPT',
    chatgpt_cta_texto: 'ChatGPT',
    chatgpt_cta_texto_title: 'Abrir o ChatGPT em uma janela para criar/refinar a copy e colar aqui',
    chatgpt_aguardando_imagem: 'Aguardando imagem do ChatGPT...',
    chatgpt_aguardando_texto: 'ChatGPT aberto — copie o texto gerado e cole no campo abaixo',
    chatgpt_passos_1_imagem: 'Peça ao ChatGPT para criar a imagem',
    chatgpt_passos_2_imagem: 'Baixe a imagem gerada (botão de download)',
    chatgpt_passos_3_imagem: 'Volte aqui e selecione o arquivo baixado',
    chatgpt_ja_baixei: 'Já baixei — selecionar arquivo',
    chatgpt_cancelar: 'Cancelar',
    midia_limite_hint: 'Tamanho máximo: {max} MB (limite do WhatsApp)',
    midia_url_label: 'URL da mídia',
    midia_url_placeholder: 'https://exemplo.com/imagem.jpg',
    mensagem_label: 'Mensagem',
    gerar_copy_title_habilitado: 'Gerar copy com base na imagem',
    gerar_copy_title_desabilitado: 'Adicione uma imagem acima para habilitar',
    gerar_copy_gerando: 'Gerando...',
    gerar_copy_btn: 'Gerar copy com IA',
    mensagem_placeholder: 'Olá {nome}, temos uma condição especial para você!',
    mensagem_hint: 'Use {nome}, {telefone} para personalizar',
    ia_titulo: '✨ Gerar variações da mensagem com IA',
    ia_ativo: 'A IA cria 5 versões da mensagem mantendo o conteúdo, tópicos, links e CTA — varia apenas o estilo. Reduz o risco de bloqueio.',
    ia_inativo: '⚠️ Sem variações: o mesmo texto será enviado a todos. Intervalo mínimo de 6s e blocos de 40 contatos / 35s entre blocos serão aplicados para reduzir o risco de bloqueio.',
    email_assunto_label: 'Assunto do email',
    email_assunto_tooltip: 'Linha de assunto que aparecerá na caixa de entrada do destinatário. Use {nome} para personalizar.',
    email_assunto_tooltip_exemplo: 'Olá {nome}, confira nossa oferta especial!',
    email_assunto_placeholder: 'Ex: {nome}, temos uma oferta exclusiva para você!',
    email_fallback_label: 'Mensagem de texto (fallback)',
    email_fallback_tooltip: 'Versão em texto simples do email. Exibida em clientes que não suportam HTML.',
    email_fallback_tooltip_exemplo: 'Olá {nome}, confira nossas ofertas em nosso site.',
    email_fallback_placeholder: 'Olá {nome}, confira nossas ofertas...',
    email_corpo_label: 'Corpo do email',
    email_corpo_tooltip: 'Editor visual do corpo do email. Use a barra de ferramentas para formatar texto, inserir imagens e links. Alterne para modo HTML para edição avançada.',
    email_corpo_tooltip_exemplo: 'Crie emails profissionais sem precisar saber HTML',
    email_usar_template: '📄 Usar template',
    email_hint: 'Use {nome}, {telefone}, {email} para personalizar. Clique em 📁 na barra para fazer upload de imagens.',
    email_preview_label: '📧 Preview do email',
    email_preview_de: 'De:',
    email_preview_assunto: 'Assunto:',
    email_preview_sem_assunto: '(sem assunto)',
    intervalo_secao: 'Intervalo entre {canal}',
    intervalo_canal_emails: 'emails',
    intervalo_canal_mensagens: 'mensagens',
    intervalo_hint_opcional: '(opcional — deixe em branco para envio imediato)',
    intervalo_min_label: 'Mínimo (seg)',
    intervalo_min_placeholder: 'Ex: 15',
    intervalo_descricao_com_valor: 'O intervalo entre cada envio varia aleatoriamente entre o mínimo informado e {max} (mínimo + 15 s), simulando comportamento humano.',
    intervalo_descricao_sem_valor: 'O intervalo varia aleatoriamente (mínimo + 15 s), simulando comportamento humano.',
    blocos_secao: 'Envio em blocos',
    blocos_hint_opcional: '(opcional — pausa maior a cada N contatos)',
    blocos_tamanho_label: 'Tamanho do bloco',
    blocos_tamanho_placeholder: 'Ex: 20',
    blocos_intervalo_label: 'Intervalo entre blocos (seg)',
    blocos_intervalo_placeholder: 'Ex: 300 (5 min)',
    blocos_descricao: 'Quando definidos, após cada {n} contato(s) o envio pausa por {x} segundo(s) antes de continuar. Preencha os dois campos para ativar.',
    janela_secao: 'Janela de envio',
    janela_hint_opcional: '(opcional — deixe em branco para enviar a qualquer hora)',
    janela_hora_inicio_label: 'Hora início',
    janela_hora_fim_label: 'Hora fim',
    janela_data_inicio_label: 'Data início',
    janela_dias_label: 'Dias da semana (clique para selecionar)',
    dia_seg: 'Seg',
    dia_ter: 'Ter',
    dia_qua: 'Qua',
    dia_qui: 'Qui',
    dia_sex: 'Sex',
    dia_sab: 'Sáb',
    dia_dom: 'Dom',
    janela_descricao: 'Disparo pausado automaticamente ao atingir a hora fim e retomado no dia seguinte do ponto onde parou. Só envia nos dias da semana selecionados.',
    btn_proximo: 'Próximo — Selecionar contatos →',
    grupos_label: 'Selecionar por grupos',
    filtrar_instancia: 'Filtrar por instância',
    filtrar_todas: 'Todas',
    btn_desmarcar_todos: 'Desmarcar todos',
    btn_selecionar_todos: 'Selecionar todos',
    btn_desmarcar_instancia: 'Desmarcar {inst}',
    btn_selecionar_instancia: 'Selecionar {inst}',
    btn_importar_csv: 'Importar CSV',
    btn_importando: 'Importando...',
    btn_contato_manual: '+ Contato manual',
    contadores_filtrado: '{sel} de {total} ({inst})',
    contadores_geral: '{sel} de {total} selecionados',
    csv_hint: '📄 O CSV deve ter colunas: nome, telefone, email (apenas telefone é obrigatório)',
    form_contato_titulo: 'Adicionar contato manualmente',
    form_contato_nome: 'Nome',
    form_contato_telefone: 'Telefone',
    form_contato_email: 'Email',
    form_contato_salvar: 'Salvar e selecionar',
    form_contato_salvando: 'Salvando...',
    form_contato_cancelar: 'Cancelar',
    importados_titulo: '📥 Contatos importados agora ({n}) · {sel} selecionado(s)',
    importados_desmarcar: 'Desmarcar todos',
    importados_selecionar: 'Selecionar todos',
    importados_fechar: 'Fechar lista de importados',
    busca_placeholder: 'Buscar por nome ou número...',
    vazio_nenhum_contato: 'Nenhum contato cadastrado. Importe um CSV ou adicione manualmente.',
    vazio_filtro_instancia: 'Nenhum contato na instância "{inst}"',
    vazio_busca: 'Nenhum contato encontrado',
    btn_voltar: '← Voltar',
    btn_criar_campanha: '🚀 Criar campanha com {n} contato(s)',
    btn_criando: 'Criando campanha...',
    toast_csv_importados: '{n} contatos importados!',
    toast_csv_erro: 'Erro ao importar CSV',
    toast_contato_telefone_obrigatorio: 'Telefone é obrigatório',
    toast_contato_adicionado: 'Contato adicionado!',
    toast_contato_erro: 'Erro ao adicionar contato',
    toast_sem_contatos: 'Selecione pelo menos um contato ou grupo',
    toast_midia_url_vazia: 'Informe a URL da mídia ou desmarque a opção',
    toast_email_sem_assunto: 'Informe o assunto do email',
    toast_sem_instancia: 'Selecione uma instância de WhatsApp antes de enviar',
    toast_instancia_invalida: 'A instância selecionada não pertence à sua conta',
    toast_campanha_criada: 'Campanha criada! Confirme o início do envio na lista.',
    toast_campanha_erro: 'Erro ao criar campanha',
    toast_midia_enviada: 'Arquivo enviado!',
    toast_midia_erro: 'Erro ao enviar arquivo',
    toast_midia_grande: 'Arquivo muito grande. O limite para {tipo} é {max} MB.',
    toast_copy_gerada: 'Copy gerada com IA! Edite à vontade.',
    toast_copy_erro: 'Erro ao gerar copy. Verifique se a IA está configurada.',
    validacao_nome: 'Nome da campanha é obrigatório',
    validacao_mensagem: 'Mensagem é obrigatória',
    validacao_email_assunto: 'Assunto do email é obrigatório',
    validacao_email_corpo: 'Informe o corpo do email ou a mensagem de texto',
    validacao_intervalo_minimo: 'O intervalo mínimo entre mensagens deve ser de pelo menos 15 segundos',
    filtro_business_secao: 'Filtro por tipo de conta',
    filtro_business_hint: 'selecione quais contas receberão esta campanha',
    filtro_business_label: 'Tipo de conta',
    filtro_business_todos: 'Todos os contatos',
    filtro_business_somente_business: 'Somente WhatsApp Business',
    filtro_business_somente_pessoal: 'Somente contas pessoais',
    filtro_business_descricao: 'Contas Business pertencem a empresas — menor risco de reportar spam. O tipo é detectado automaticamente ao importar contatos.',
    filtro_tags_secao: 'Filtro por tag',
    filtro_tags_todos: 'Todas as tags',
    detectar_business_btn: 'Detectar Business',
    detectar_business_hint: 'Verifica na Evolution API quais contatos têm conta Business (apenas os ainda não verificados)',
    detectar_business_em_andamento: 'Detectando {processados}/{total}…',
    detectar_business_iniciado: 'Detecção iniciada para {total} contatos — aguarde…',
    detectar_business_concluido: 'Detecção concluída: {atualizados}/{total} contatos atualizados',
    detectar_business_nada_fazer: 'Todos os contatos já foram verificados',
    detectar_business_erro: 'Falha na detecção: {erro}',
    validacao_blocos_sem_ia: 'Sem variações de IA: configure o envio em blocos (tamanho e intervalo) para reduzir risco de bloqueio',
  },

  campanhas: {
    titulo: 'Campanhas',
    subtitulo: 'Crie, monitore e reenvie campanhas com controle de pausa, intervalo e blocos.',
    btn_nova: 'Nova campanha',
    col_nome: 'Nome',
    col_status: 'Status',
    col_horario: 'Horário',
    col_intervalo: 'Intervalo',
    col_criada_em: 'Criada em',
    col_acoes: 'Ações',
    badge_nova: 'Nova',
    status_finalizado: 'Finalizado',
    status_pendente: 'Pendente',
    status_processando: 'Processando',
    status_pausada: 'Pausada',
    status_sem_instancia: 'Sem instância',
    status_aguardando_horario: 'Fora do horário',
    status_limite_diario: 'Limite do dia',
    status_bloqueio_detectado: 'Verificar chip',
    status_plano_vencido: 'Plano vencido',
    status_erro: 'Erro',
    tooltip_limite_diario: 'O limite diário de envios desta instância foi atingido. A campanha retomará automaticamente amanhã.',
    tooltip_bloqueio: 'Detectamos 3 ou mais falhas seguidas — o chip pode estar com restrição do WhatsApp. Verifique o WhatsApp conectado e clique em Reativar quando estiver tudo ok.',
    tooltip_sem_instancia: 'O WhatsApp desta campanha está desconectado. Reconecte o chip em Menu → WhatsApp.',
    tooltip_aguardando_horario: 'A campanha está fora da janela de horário configurada. Retomará automaticamente no próximo horário de início.',
    intervalo_imediato: 'Imediato',
    btn_iniciar_envio: 'Iniciar envio',
    btn_pausar: 'Pausar',
    btn_retomar: 'Retomar',
    btn_reativar: 'Reativar',
    btn_reenviar: 'Reenviar',
    btn_deletar: 'Deletar',
    vazio: 'Nenhuma campanha criada ainda',
    detalhe_titulo: '{nome}',
    detalhe_status: 'Status',
    detalhe_tipo: 'Tipo',
    detalhe_instancia: 'Instância',
    detalhe_intervalo: 'Intervalo',
    detalhe_bloco: 'Bloco',
    detalhe_bloco_valor: '{tamanho} contatos · pausa {intervalo}s',
    detalhe_horario: 'Horário',
    detalhe_progresso: 'Progresso',
    detalhe_progresso_valor: '{n} enviados',
    detalhe_mensagem: 'Mensagem',
    detalhe_contatos: 'Contatos vinculados ({n})',
    reenvio_titulo: 'Reenviar — {nome}',
    reenvio_hint: 'Deixe em branco para reenviar para os mesmos contatos da campanha original, ou selecione uma nova lista abaixo.',
    reenvio_instancia_label: '📲 Instância WhatsApp',
    reenvio_grupos_label: 'Selecionar grupos',
    reenvio_grupos_selecionados: '· {n} selecionado(s)',
    reenvio_desmarcar_todos: 'Desmarcar todos',
    reenvio_selecionar_todos: 'Selecionar todos',
    reenvio_importar_csv: 'Importar nova lista (CSV)',
    reenvio_importando: 'Importando...',
    reenvio_contadores: '{sel} / {total} selecionados',
    reenvio_importados_titulo: '📥 Importados agora ({n}) · {sel} selecionado(s)',
    reenvio_selecionar_contatos: 'Selecionar contatos',
    reenvio_busca_placeholder: 'Buscar por nome ou telefone...',
    reenvio_vazio: 'Nenhum contato encontrado',
    reenvio_cancelar: 'Cancelar',
    reenvio_btn: '🚀 Reenviar campanha',
    confirmar_inicio_titulo: 'Confirmar início do envio',
    confirmar_inicio_descricao: 'Você está prestes a iniciar o envio da campanha',
    confirmar_aviso_titulo: '⚠️ Aviso importante',
    confirmar_aviso_texto: 'A prática de envio em massa pelo WhatsApp pode causar restrições, bloqueio temporário ou banimento permanente do número utilizado. Use intervalos entre mensagens, janelas de horário razoáveis e envie apenas para contatos que esperam ouvir de você. Você é o único responsável pelo uso da ferramenta e pelas consequências do envio.',
    confirmar_aceitar_termos: 'Li e aceito os termos. Entendo que o envio em massa pode gerar restrições ou banimento do meu WhatsApp e assumo a responsabilidade pelo envio.',
    confirmar_cancelar: 'Cancelar',
    confirmar_iniciando: 'Iniciando...',
    confirmar_btn_iniciar: '🚀 Iniciar envio',
    toast_pausada: 'Campanha pausada',
    toast_erro_pausar: 'Erro ao pausar',
    toast_retomada: 'Campanha retomada',
    toast_erro_retomar: 'Erro ao retomar',
    toast_reativada: 'Campanha reativada! Será processada em instantes.',
    toast_erro_reativar: 'Erro ao reativar',
    confirm_deletar: 'Deletar campanha "{nome}"?',
    toast_deletada: 'Campanha deletada',
    toast_erro_deletar: 'Erro ao deletar',
    toast_erro_detalhe: 'Erro ao carregar detalhes',
    toast_reenviada: 'Campanha reenviada!',
    toast_erro_reenviar: 'Erro ao reenviar campanha',
    toast_csv_importados: '{n} contatos importados!',
    toast_csv_erro: 'Erro ao importar CSV',
    toast_iniciado: 'Envio iniciado!',
    toast_erro_iniciar: 'Erro ao iniciar envio',
  },

  contatos: {
    titulo: 'Contatos',
    subtitulo_filtrado: '({filtrado} de {total})',
    subtitulo: '({total})',
    pagina_sub: 'Gerencie contatos e grupos organizados por instância do WhatsApp.',
    btn_remover_dup: 'Remover duplicados',
    btn_limpar_invalidos: 'Limpar inválidos',
    btn_excluir_sel: 'Excluir selecionados ({n})',
    btn_novo: 'Novo contato',
    form_titulo: 'Novo contato',
    col_nome: 'Nome',
    col_telefone: 'Telefone',
    col_email: 'Email',
    col_instancia: 'Instância',
    col_ia: 'Concierge IA',
    col_cadastrado: 'Cadastrado em',
    col_acoes: 'Ações',
    ia_ativar_title: 'Ativar Concierge IA para este contato',
    ia_desativar_title: 'Desativar Concierge IA para este contato',
    toast_ia_ativada: 'Concierge IA ativada para o contato',
    toast_ia_desativada: 'Concierge IA desativada para o contato',
    toast_erro_ia: 'Erro ao alterar a Concierge IA do contato',
    todas_instancias: 'Todas as instâncias',
    placeholder_telefone: '5561999999999',
    btn_salvar: 'Salvar contato',
    toast_telefone_obrigatorio: 'Telefone é obrigatório',
    toast_adicionado: 'Contato adicionado!',
    toast_erro_adicionar: 'Erro ao adicionar contato',
    toast_atualizado: 'Contato atualizado!',
    toast_erro_atualizar: 'Erro ao atualizar contato',
    confirm_remover: 'Remover contato "{nome}"?',
    toast_removido: 'Contato removido!',
    toast_erro_remover: 'Erro ao remover contato',
    confirm_limpar_lids: 'Remover contatos com telefone inválido (LIDs do WhatsApp e números fora do padrão)? Eles ficarão ocultos mas preservados no histórico.',
    toast_lids_removidos: '{n} contato(s) inválido(s) removido(s)',
    toast_nenhum_invalido: 'Nenhum contato inválido encontrado',
    toast_erro_limpar: 'Erro ao limpar contatos',
    confirm_dedup: 'Remover entradas duplicadas de um mesmo número de telefone? O registro mais completo será mantido.',
    toast_dup_removidos: '{n} duplicata(s) removida(s)',
    toast_nenhum_dup: 'Nenhuma duplicata encontrada',
    toast_erro_dedup: 'Erro ao remover duplicados',
    toast_csv_nenhum: 'Nenhum contato foi importado. Confira se a planilha tem uma coluna de telefone.',
    toast_csv_reativados: '{n} contato(s) estavam desativados e foram reativados por este arquivo.',
    toast_csv_timeout: 'A importação demorou mais que o esperado e o navegador desistiu de esperar. Os contatos podem ter entrado mesmo assim — atualize a lista antes de tentar de novo.',
    toast_csv_rede: 'Não consegui falar com o servidor para importar. Confira sua conexão e tente de novo.',
    import_instancia_label: 'Importar em:',
    import_instancia_nenhuma: 'Sem instância',
    import_instancia_hint: 'Opcional — organiza os contatos importados sob uma instância. Não muda por qual número a campanha dispara.',
    toast_csv_importados_instancia: '{n} contato(s) importado(s) em {instancia}',
    toast_csv_truncados: '{n} contato(s) NÃO foram importados: seu plano permite {limite}. Faça upgrade ou adquira créditos.',
    toast_csv_sem_telefone: '{n} linha(s) do arquivo não tinham telefone e foram ignoradas.',
    confirm_excluir_massa: 'Remover {n} contato(s) selecionado(s)?',
    toast_excluidos: '{n} contato(s) removido(s)!',
    toast_erro_excluir_massa: 'Erro ao remover {n} contato(s)',
    vazio_instancia: 'Nenhum contato para "{inst}". Sincronize via painel WhatsApp.',
    vazio: 'Nenhum contato cadastrado ainda',
    grupos_titulo: 'Grupos',
    grupos_gerar_auto: 'Gerar automático',
    grupos_com_sel: '+ Grupo com {n} selecionado(s)',
    grupos_novo: 'Novo grupo',
    grupos_auto_titulo: '⚡ Gerar grupos automáticos',
    grupos_auto_sub: 'Divide contatos em grupos de N cada, respeitando a instância selecionada.',
    grupos_instancia_label: 'Instância',
    grupos_instancia_todas: 'Todas as instâncias ({n} contatos)',
    grupos_tamanho_label: 'Contatos por grupo',
    grupos_prefixo_label: 'Prefixo do nome',
    grupos_resultado: 'Resultado: ~{grupos} grupos de {tam} contatos ({total} total)',
    grupos_gerando: 'Gerando...',
    grupos_gerar_btn: 'Gerar {n} grupos',
    grupos_vazio_instancia: 'Nenhum grupo para a instância "{inst}".',
    grupos_vazio: 'Nenhum grupo criado. Crie um para organizar seus contatos.',
    modal_grupo_titulo: 'Novo grupo',
    modal_nome_label: 'Nome do grupo',
    modal_nome_placeholder: 'Ex: Pacientes de retorno',
    modal_descricao_label: 'Descrição',
    modal_descricao_placeholder: 'Ex: campanha março',
    modal_instancia_label: 'Instância',
    modal_instancia_todas: '— todas —',
    modal_contatos_label: 'Contatos ({n} selecionados)',
    modal_buscar: 'Buscar...',
    modal_criar_btn: 'Criar grupo ({n})',
    modal_criar_btn_sem: 'Criar grupo',
    modal_nome_obrigatorio: 'Nome do grupo é obrigatório',
    modal_criado: 'Grupo criado! {n} contato(s) adicionado(s).',
    modal_criado_sem: 'Grupo criado!',
    modal_erro_criar: 'Erro ao criar grupo',
    grupo_salvar: 'Salvar ({n})',
    grupo_salvando: 'Salvando...',
    grupo_atualizado: 'Grupo atualizado!',
    grupo_erro_salvar: 'Erro ao salvar grupo',
    confirm_excluir_grupo: 'Excluir grupo "{nome}"? Os contatos não serão removidos.',
    toast_grupo_excluido: 'Grupo excluído!',
    toast_erro_excluir_grupo: 'Erro ao excluir grupo',
    buscar_contato: 'Buscar contato...',
    nenhum_contato: 'Nenhum contato',
    selecionar_todos: 'Selecionar todos visíveis',
    col_tags: 'Tags',
    tags_placeholder: 'vip, retorno, paciente',
    tags_hint: 'Separe por vírgula. Ex: vip, retorno',
    todas_tags: 'Todas as tags',
    toast_atualizado_tags: 'Tags atualizadas!',
  },

  grupos: {
    titulo: 'Grupos',
    subtitulo: '({n})',
    pagina_sub: 'Organize contatos em grupos manuais ou gerados automaticamente.',
    btn_gerar_auto: 'Gerar automático',
    btn_novo: 'Novo grupo',
    aviso_ban: '⚠️ Disparar para muitos grupos simultâneos pode resultar em ban ou restrição pelo WhatsApp. Use com moderação.',
    auto_titulo: '⚡ Gerar grupos automáticos',
    auto_sub: 'Divide todos os {n} contatos em grupos de N contatos cada.',
    tamanho_label: 'Contatos por grupo',
    prefixo_label: 'Prefixo do nome',
    resultado: 'Resultado: ~{grupos} grupos de {tam} contatos',
    gerando: 'Gerando...',
    gerar_btn: 'Gerar {n} grupos',
    form_titulo: 'Novo grupo manual',
    form_nome_label: 'Nome do grupo',
    form_nome_placeholder: 'Ex: Pacientes de retorno',
    form_instancia_label: 'Instância',
    form_instancia_todas: 'Todas',
    form_descricao_label: 'Descrição',
    form_descricao_placeholder: 'Opcional',
    form_contatos_label: 'Contatos ({sel} selecionados de {total})',
    form_limpar: 'Limpar seleção',
    form_buscar: 'Buscar por nome ou telefone...',
    form_nenhum_contato: 'Nenhum contato importado',
    form_nenhum_instancia: 'Nenhum contato nesta instância',
    form_criando: 'Criando...',
    form_criar: 'Criar grupo',
    col_nome: 'Nome',
    col_descricao: 'Descrição',
    col_contatos: 'Contatos',
    col_criado: 'Criado em',
    badge_contatos: '{n} contatos',
    gerenciar_label: 'Gerenciar contatos — {nome}',
    gerenciar_sel: '{n} selecionados',
    buscar_contato: 'Buscar contato...',
    nenhum_contato: 'Nenhum contato',
    salvando: 'Salvando...',
    salvar: 'Salvar',
    vazio: 'Nenhum grupo criado ainda',
    toast_nome_obrigatorio: 'Nome é obrigatório',
    toast_criado: 'Grupo criado!',
    toast_erro_criar: 'Erro ao criar grupo',
    toast_gerados: '{n} grupos gerados!',
    toast_erro_gerar: 'Erro ao gerar grupos',
    confirm_deletar: 'Deletar grupo "{nome}"?',
    toast_deletado: 'Grupo deletado',
    toast_erro_deletar: 'Erro ao deletar grupo',
    toast_atualizados: 'Contatos atualizados',
    toast_erro_salvar: 'Erro ao salvar',
  },

  envios: {
    titulo: 'Envios',
    atualizado_as: 'Atualizado às {hora}',
    btn_atualizar: 'Atualizar',
    btn_exportar_csv: 'Exportar CSV',
    selecionar_campanha: 'Selecionar campanha',
    selecione_opcao: 'Selecione uma campanha...',
    contagem: '{n} envio(s) encontrado(s)',
    col_contato: 'Contato',
    col_telefone: 'Telefone',
    col_status: 'Status',
    col_mensagem: 'Mensagem enviada',
    col_data: 'Data',
    vazio: 'Nenhum envio encontrado para esta campanha',
  },

  metricas: {
    titulo: 'Métricas de campanha',
    subtitulo: 'Taxa de entrega, distribuição por hora e principais erros por campanha.',
    selecionar_campanha: 'Selecionar campanha',
    selecione_opcao: 'Selecione uma campanha...',
    btn_atualizar: 'Atualizar',
    carregando: 'Carregando métricas...',
    sem_dados: 'Sem dados para esta campanha ainda.',
    sem_erros: 'Sem erros registrados.',
    kpi_total: 'Total',
    kpi_enviados: 'Enviados',
    kpi_erros: 'Erros',
    kpi_pendentes: 'Pendentes',
    kpi_taxa: 'Taxa de entrega',
    kpi_tentativas: 'Média de tentativas',
    grafico_status: 'Distribuição por status',
    grafico_hora: 'Envios por hora do dia',
    top_erros_titulo: 'Principais erros',
    col_erro: 'Mensagem de erro',
    col_ocorrencias: 'Ocorrências',
    status_enviado: 'Enviado',
    status_erro: 'Erro',
    status_pendente: 'Pendente',
  },

  configuracoes: {
    titulo: 'Configurações',
    subtitulo: 'Gerencie acesso, integrações e disparos por email.',
    salvando: 'Salvando...',
    btn_salvar: 'Salvar',
    sec_senha: 'Alterar senha',
    label_senha_atual: 'Senha atual',
    label_nova_senha: 'Nova senha',
    label_confirmar_senha: 'Confirmar nova senha',
    btn_alterar_senha: 'Alterar senha',
    toast_campos_obrigatorios: 'Preencha todos os campos',
    toast_senhas_nao_conferem: 'As senhas não conferem',
    toast_senha_curta: 'A nova senha deve ter no mínimo 6 caracteres',
    toast_senha_alterada: 'Senha alterada com sucesso!',
    toast_erro_senha: 'Erro ao alterar senha',
    sec_email: 'Alterar email',
    email_atual_label: 'Email atual:',
    label_novo_email: 'Novo email',
    label_confirmar_senha_email: 'Confirme sua senha',
    warn_email: '⚠️ Após alterar o email, você precisará fazer login novamente.',
    btn_alterar_email: 'Alterar email',
    toast_email_alterado: 'Email alterado! Faça login novamente.',
    toast_erro_email: 'Erro ao alterar email',
    sec_push: 'Notificações push',
    push_sem_suporte: 'Seu navegador não suporta notificações push. Use Chrome, Edge ou Firefox.',
    push_bloqueado: '⚠️ Você bloqueou notificações para este site. Reabilite nas configurações do navegador (clique no cadeado ao lado da URL) e atualize a página.',
    push_descricao: 'Receba alertas no seu dispositivo quando uma campanha terminar ou quando uma instância de WhatsApp desconectar — funciona mesmo com o painel fechado.',
    push_ativo: '✅ Notificações ativadas neste dispositivo.',
    btn_teste_push: 'Enviar teste',
    btn_desativar_push: 'Desativar',
    btn_ativar_push: 'Ativar notificações neste dispositivo',
    btn_ativando_push: 'Ativando...',
    toast_push_ativado: 'Notificações ativadas! 🔔',
    toast_push_desativado: 'Notificações desativadas',
    toast_push_erro_desativar: 'Erro ao desativar',
    toast_push_teste: 'Teste enviado! Confira a notificação.',
    toast_push_erro_teste: 'Erro ao enviar teste',
    sec_whatsapp: '📲 Evolution API (WhatsApp)',
    label_url_api: 'URL da API',
    label_api_key: 'API Key',
    toast_config_salvas: 'Configurações salvas!',
    toast_erro_salvar: 'Erro ao salvar',
    sec_openai: '🤖 OpenAI',
    openai_warn: '⚠️ Necessário para variações de mensagem com IA. Sem a chave, variações locais são usadas.',
    sec_blacklist: 'Blacklist — contatos que pediram remoção',
    blacklist_todas: 'Todas ({n})',
    blacklist_vazio: '✅ Nenhum contato na blacklist',
    blacklist_vazio_instancia: '✅ Nenhum contato na blacklist da instância "{instancia}".',
    blacklist_bloqueado_em: 'Bloqueado em {data}',
    toast_blacklist_removido: 'Contato removido da blacklist',
    toast_blacklist_erro: 'Erro ao remover da blacklist',
    sec_cap: 'Warm-up e cap diário por instância',
    cap_col_instancia: 'Instância',
    cap_col_empresa: 'Empresa',
    cap_col_dias: 'Dias de uso',
    cap_col_cap_auto: 'Cap automático',
    cap_col_override: 'Override manual',
    cap_col_enviados: 'Enviados hoje',
    cap_aquecendo: 'Dia {dia} (aquecendo)',
    cap_dias: '{n} dias',
    cap_por_dia: '{n}/dia',
    cap_placeholder: 'Auto',
    toast_cap_atualizado: 'Cap atualizado',
    toast_cap_erro: 'Erro ao salvar cap',
    sec_garantia: 'Garantia de 7 dias',
    garantia_reembolso_solicitado: '✅ Sua solicitação de reembolso foi recebida. Entraremos em contato em até 24 horas para processar o cancelamento.',
    garantia_texto: 'Você está dentro do prazo de garantia de 7 dias. Se não estiver satisfeito, você pode solicitar o reembolso integral e cancelaremos sua conta sem questionamentos.',
    garantia_prazo: 'Prazo restante: {dias} dia(s).',
    btn_solicitar_reembolso: '↩ Solicitar reembolso',
    btn_enviando: 'Enviando...',
    toast_reembolso_enviado: 'Solicitação enviada! Entraremos em contato em até 24h.',
    toast_reembolso_erro: 'Erro ao solicitar reembolso. Tente novamente.',
    confirm_reembolso: 'Tem certeza que deseja solicitar o reembolso? Sua conta será cancelada após o processamento.',
    sec_smtp: '📧 Disparos por Email (SMTP)',
    smtp_ativo: '✅ Addon de email ativo — configure seu servidor SMTP abaixo',
    smtp_where: '📖 Onde encontrar os dados SMTP? Acesse as configurações do seu provedor de email:',
    label_smtp_host: 'Host SMTP',
    label_smtp_porta: 'Porta',
    label_smtp_from: 'Email remetente',
    label_smtp_user: 'Usuário',
    label_smtp_pass: 'Senha',
    btn_salvar_smtp: 'Salvar configurações de email',
    addon_titulo: 'Adicione o módulo de disparos por email ao seu plano',
    addon_descricao: 'Envie campanhas por email além do WhatsApp. Configure seu próprio servidor SMTP.',
    addon_periodo: '/mês',
    btn_contratar_addon: '💳 Contratar addon de email',
    btn_processando: 'Processando...',
    addon_rodape: 'Pagamento seguro via Stripe · Liberação imediata após confirmação',
    toast_addon_ativado: 'Addon de email ativado com sucesso! 🎉',
    toast_addon_erro: 'Erro ao ativar addon. Entre em contato pelo suporte.',
    toast_addon_contratar_erro: 'Erro ao processar. Tente novamente.',
  },

  redefinir: {
    titulo: 'Redefinir senha',
    subtitulo: 'Escolha uma nova senha para sua conta',
    label_nova_senha: 'Nova senha',
    label_confirmar: 'Confirmar senha',
    btn_salvar: 'Redefinir senha',
    btn_salvando: 'Salvando...',
    sucesso: 'Senha redefinida com sucesso!',
    sucesso_titulo: 'Tudo certo!',
    sucesso_redirect: 'Redirecionando para o login...',
    erro_token: 'Token de redefinição inválido',
    erro_curta: 'A senha deve ter pelo menos 6 caracteres',
    erro_diferente: 'As senhas não coincidem',
    erro_generico: 'Erro ao redefinir senha. O link pode ter expirado.',
    erro_sem_token: 'Link de redefinição inválido ou ausente. Solicite um novo.',
    voltar_login: 'Voltar para o login',
  },

  creditos: {
    titulo: 'Créditos Avulsos',
    subtitulo: 'Complemente os limites do seu plano sem precisar fazer upgrade.',
    carregando: 'Carregando...',
    freemium_titulo: 'Plano Freemium não inclui créditos avulsos',
    freemium_texto: 'Créditos avulsos estão disponíveis para assinantes Starter, Pro e Enterprise. Faça o upgrade do seu plano para desbloquear essa funcionalidade.',
    ver_planos: 'Ver planos',
    por_pack: '/pack',
    btn_comprar: 'Comprar — R$ {preco}',
    rodape: '🔒 Pagamento seguro via Stripe ou PIX · Créditos válidos até o fim do mês corrente · Sem recorrência automática',
    modal_titulo: 'Finalizar compra',
    escolha_metodo: 'Como prefere pagar?',
    pix_titulo: 'PIX',
    pix_sub: 'Instantâneo, sem taxas extras',
    cartao_titulo: 'Cartão de crédito',
    cartao_sub: 'Débito ou crédito (Stripe)',
    voltar: 'Voltar',
    label_cartao: 'Dados do cartão',
    btn_pagar: 'Pagar R$ {preco},00',
    btn_processando: 'Processando...',
    modal_rodape: '🔒 Pagamento seguro · Sem recorrência automática',
    pix_gerando: 'Gerando QR Code...',
    pix_instrucao: 'Escaneie o QR Code abaixo no seu app bancário ou copie o código PIX.',
    pix_aguardando: 'Aguardando confirmação do pagamento...',
    pix_confirmado: 'Pagamento confirmado! Os créditos serão disponibilizados em instantes.',
    copiar: 'Copiar',
    copiado: 'Copiado!',
    toast_pack_adquirido: 'Pack "{nome}" adquirido! Os créditos já estão disponíveis.',
    toast_pix_pago: 'Pagamento PIX confirmado! Créditos adicionados.',
    toast_erro_iniciar: 'Erro ao iniciar pagamento',
    pack_disparos_nome: 'Pack Disparos',
    pack_disparos_descricao: '+1.000 disparos extras',
    pack_disparos_item1: '1.000 disparos adicionais',
    pack_disparos_item2: 'Acumulam com os disparos do plano',
    pack_disparos_item3: 'Consumidos após o limite mensal',
    pack_disparos_item4: 'Válidos até o fim do mês corrente',
    pack_ia_nome: 'Pack IA',
    pack_ia_descricao: '+100 mensagens da Concierge IA',
    pack_ia_item1: '100 msgs Concierge IA extras',
    pack_ia_item2: 'Acumulam com os do plano',
    pack_ia_item3: 'Consumidos após o limite mensal',
    pack_ia_item4: 'Válidos até o fim do mês corrente',
  },

  admin: {
    titulo: 'Painel Admin',
    subtitulo: 'Gerencie clientes, planos e contas de teste.',
    carregando: 'Carregando...',
    btn_criar_usuario: '+ Criar usuário',
    stat_total_clientes: 'Total de clientes',
    stat_clientes_ativos: 'Clientes ativos',
    stat_aguardando: 'Aguardando pagamento',
    stat_total_disparos: 'Total de disparos',
    stat_total_campanhas: 'Total de campanhas',
    stat_total_contatos: 'Total de contatos',
    status_ativo: 'Ativo',
    status_pendente: 'Pendente',
    status_suspenso: 'Suspenso',
    col_empresa: 'Empresa',
    col_email: 'Email',
    col_telefone: 'Telefone',
    col_plano: 'Plano',
    col_status: 'Status',
    col_campanhas: 'Campanhas',
    col_contatos: 'Contatos',
    col_cadastro: 'Cadastro',
    col_ultimo_acesso: 'Último acesso',
    col_vencimento: 'Vencimento',
    col_acoes: 'Ações',
    clientes: 'Clientes ({n})',
    btn_gerenciar: 'Gerenciar',
    btn_ativar: 'Ativar',
    btn_reativar: 'Reativar',
    btn_suspender: 'Suspender',
    btn_deletar: 'Deletar',
    vazio: 'Nenhum cliente cadastrado ainda',
    modal_criar_titulo: 'Criar usuário',
    label_nome_empresa: 'Nome da empresa',
    label_nome_responsavel: 'Nome do responsável',
    label_email: 'Email',
    label_segmento: 'Segmento',
    placeholder_nome_empresa: 'Ex: Loja do João',
    placeholder_nome_responsavel: 'Ex: João Silva',
    placeholder_email: 'joao@email.com',
    placeholder_segmento: 'Ex: E-commerce, Saúde...',
    label_plano: 'Plano',
    label_dias_validade: 'Dias de validade',
    btn_criar: '✓ Criar usuário',
    btn_criando: 'Criando...',
    btn_cancelar: 'Cancelar',
    btn_fechar: 'Fechar',
    resultado_titulo: '✅ Conta criada com sucesso!',
    resultado_email: 'Email',
    resultado_senha: 'Senha temporária',
    resultado_plano: 'Plano',
    resultado_vencimento: 'Vencimento',
    resultado_aviso: '⚠️ Salve as credenciais agora — a senha não será exibida novamente.',
    btn_copiar_creds: '📋 Copiar credenciais',
    toast_copiado: 'Credenciais copiadas!',
    toast_criado: 'Conta criada com sucesso!',
    toast_erro_criar: 'Erro ao criar conta',
    toast_campos: 'Preencha todos os campos',
    modal_gerenciar: 'Gerenciar — {nome}',
    label_periodo: 'Período',
    periodo_mensal: 'Mensal',
    periodo_anual: 'Anual',
    periodo_teste: 'Teste',
    stat_envios: 'Envios',
    stat_email_admin: 'Email admin',
    btn_salvar_plano: 'Salvar plano',
    sec_estender: '📅 Estender validade',
    btn_aplicar: 'Aplicar',
    btn_salvando: 'Salvando...',
    vencimento_atual: 'Vencimento atual:',
    sec_senha: '🔑 Resetar senha',
    senha_resetada: '✅ Senha resetada!',
    btn_copiar: '📋 Copiar credenciais',
    btn_gerar_senha: '🔑 Gerar nova senha aleatória',
    btn_gerando: 'Gerando...',
    senha_aviso: 'A senha atual é invalidada imediatamente.',
    sec_overrides: '⚙️ Override de limites individuais',
    override_aviso: 'Deixe em branco para usar o limite do plano.',
    label_instancias: 'Instâncias',
    label_disparos_mes: 'Disparos/mês',
    label_ia_mes: 'IA msgs/mês',
    placeholder_padrao: 'Padrão do plano',
    btn_salvar_overrides: 'Salvar overrides',
    sec_creditos: '🎁 Conceder créditos avulsos',
    creditos_aviso: 'Créditos expiram ao fim do mês vigente.',
    tipo_disparos: 'Disparos',
    tipo_ia: 'Mensagens IA',
    placeholder_qtd: 'Qtd',
    placeholder_desc_credito: 'Descrição (opcional)',
    btn_conceder: 'Conceder créditos',
    toast_overrides: 'Overrides salvos',
    toast_overrides_erro: 'Erro ao salvar overrides',
    toast_creditos: '{n} créditos de {tipo} concedidos!',
    toast_creditos_qtd: 'Informe a quantidade',
    toast_creditos_erro: 'Erro ao conceder créditos',
    toast_ativado: 'Tenant ativado!',
    toast_ativar_erro: 'Erro ao ativar',
    confirm_suspender: 'Suspender "{nome}"?',
    toast_suspenso: 'Tenant suspenso',
    toast_suspender_erro: 'Erro ao suspender',
    toast_plano_atualizado: 'Plano atualizado!',
    toast_plano_erro: 'Erro ao alterar plano',
    confirm_resetar: 'Gerar nova senha aleatória para este cliente?',
    toast_resetar_erro: 'Erro ao resetar senha',
    toast_estendido: 'Validade estendida até {data}',
    toast_estender_erro: 'Erro ao estender validade',
    confirm_deletar: 'Deletar permanentemente "{nome}"? Todos os dados serão perdidos.',
    toast_deletado: 'Tenant deletado',
    toast_deletar_erro: 'Erro ao deletar',
    auditoria_titulo: 'Auditoria — campanhas com instância errada',
    auditoria_verificar: 'Verificar',
    auditoria_atualizar: 'Atualizar',
    auditoria_vazio_info: 'Clique em "Verificar" para listar campanhas que foram enviadas com a instância de outro tenant.',
    auditoria_ok: '✅ Nenhuma campanha com instância errada encontrada.',
    col_campanha: 'Campanha',
    col_empresa_dona: 'Empresa dona',
    col_instancia_errada: 'Instância atual (errada)',
    col_dono_instancia: 'Dono da instância atual',
    col_enviados: 'Enviados',
    col_nova_instancia: 'Nova instância',
    sem_instancia_disponivel: 'Sem instância disponível',
    selecionar_placeholder: 'Selecionar...',
    btn_reatribuir: 'Reatribuir',
    toast_reatribuido: 'Instância reatribuída para "{nome}"',
    toast_reatribuir_erro: 'Erro ao reatribuir',
    toast_select_instancia: 'Selecione uma instância',
    toast_erro_auditoria: 'Erro ao carregar auditoria',
    toast_erro_dashboard: 'Erro ao carregar painel admin',
    skeleton_empresa: 'Empresa',
    skeleton_cadastro: 'Cadastro',
    skeleton_acoes: 'Ações',
  },

  configuracao_ia: {
    titulo: 'Concierge IA',
    subtitulo: 'Configure sua atendente virtual para responder automaticamente no WhatsApp.',
    label_instancia: 'Instância',
    sem_instancia: 'Você ainda não tem instâncias do WhatsApp. Crie uma na aba WhatsApp primeiro.',
    quota_sem_plano: '⚠️ Plano {plano} não inclui a Concierge IA',
    quota_upgrade: 'Faça upgrade para o plano Pro (500 msgs/mês) ou Enterprise (2.000 msgs/mês) para ativar.',
    uso_mes: 'Uso este mês ({mes})',
    uso_mensagens: '{usado} / {limite} mensagens',
    toggle_titulo: 'Respostas automáticas',
    toggle_ativo: 'IA ativa — respondendo mensagens recebidas',
    toggle_inativo: 'IA desativada',
    sec_secretaria: 'Concierge IA',
    sec_secretaria_desc: 'Responda as perguntas abaixo e a IA cria uma atendente personalizada para seu negócio.',
    configurada: 'Concierge configurada',
    btn_reconfigurar: 'Reconfigurar',
    step1: '1. Qual é o tipo do seu negócio?',
    step2: '2. Como sua concierge deve se comunicar?',
    step3: '3. Configure sua concierge',
    label_nome_secretaria: 'Como se chama sua secretária?',
    placeholder_nome_secretaria: 'Ex: Júlia, Sofia, Ana',
    hint_nome_secretaria: 'A IA vai usar esse nome para se apresentar nas conversas.',
    label_objetivo_conversa: 'Qual o objetivo principal da sua concierge?',
    obj_agendar_nome: 'Agendar consultas / visitas',
    obj_agendar_desc: 'Coleta dados e agenda pelo WhatsApp',
    obj_qualificar_nome: 'Entender o caso',
    obj_qualificar_desc: 'Coleta o interesse e repassa à recepção',
    obj_vender_nome: 'Fechar vendas',
    obj_vender_desc: 'Conduz o cliente até a decisão de compra',
    obj_informar_nome: 'Tirar dúvidas',
    obj_informar_desc: 'Responde sobre produtos, serviços e preços',
    label_descricao_negocio: 'Descreva seu negócio em 1 ou 2 frases',
    placeholder_descricao_negocio: 'Ex: Clínica odontológica especializada em ortodontia e estética dental para adultos e crianças em São Paulo.',
    label_publico_alvo: 'Quem é seu cliente típico?',
    placeholder_publico_alvo: 'Ex: Adultos de 25 a 50 anos, que buscam tratamento estético e já tiveram experiências ruins com outros dentistas.',
    label_dados_coletar: 'O que sua concierge deve saber do paciente antes de encaminhar?',
    hint_dados_coletar: 'O funil de qualificação será construído com base nesses dados — marque na ordem em que deseja perguntar.',
    dado_nome: 'Nome completo',
    dado_telefone: 'Telefone para contato',
    dado_email: 'E-mail',
    dado_cidade: 'Cidade / Bairro',
    dado_servico: 'Serviço ou produto de interesse',
    dado_orcamento: 'Orçamento disponível',
    dado_data: 'Data / horário preferido',
    dado_empresa: 'Empresa / CNPJ',
    dado_quantidade: 'Número de pessoas ou alunos',
    label_objetivo: 'Qual o objetivo do seu negócio?',
    label_servicos: 'Quais serviços ou produtos você oferece?',
    label_horario: 'Horário de funcionamento',
    label_contato: 'Como os clientes agendam ou entram em contato?',
    label_pagamento: 'Formas de pagamento aceitas',
    label_profissional: 'Profissional ou especialista de destaque',
    label_diferencial: 'Qual o maior diferencial do seu negócio?',
    label_restricoes: 'Restrições ou informações importantes',
    label_localizacao: 'Cidade e bairro',
    label_cursos: 'Oferece cursos ou treinamentos?',
    opcional: '(opcional)',
    placeholder_objetivo: 'Ex: Somos uma clínica odontológica especializada em...',
    placeholder_servicos: 'Ex: Aparelho fixo, clareamento dental, implante, limpeza...',
    placeholder_horario: 'Ex: Seg-Sex 8h-18h, Sáb 8h-12h',
    placeholder_profissional: 'Ex: Dra. Ana, 15 anos de experiência em...',
    placeholder_diferencial: 'O que te diferencia dos concorrentes...',
    placeholder_restricoes: 'Ex: Apenas particular, sem convênio. Estacionamento gratuito...',
    placeholder_localizacao: 'Ex: São Paulo, Pinheiros',
    placeholder_cursos: 'Descreva os cursos...',
    btn_gerar: '✨ Configurar Concierge com IA',
    btn_gerando: 'Gerando configuração...',
    toast_ia_ativada: 'IA ativada',
    toast_ia_desativada: 'IA desativada',
    toast_configurada: 'Concierge configurada com sucesso!',
    toast_erro_gerar: 'Erro ao gerar configuração',
    toast_salvo: 'Configuração salva',
    conflito_titulo: 'Trechos desta configuração podem conflitar com as regras fixas do sistema:',
    conflito_confirm: 'Esta configuração pode conflitar com as Regras Absolutas do sistema, que têm prioridade:',
    conflito_confirm_pergunta: 'Deseja salvar mesmo assim?',
    toast_erro_salvar: 'Erro ao salvar',
    toast_erro_diagnostico: 'Erro no diagnóstico',
    toast_erro_testar: 'Erro ao testar IA',
    erro_tipo_negocio: 'Selecione o tipo de negócio',
    erro_estilo: 'Selecione o estilo de comunicação da sua concierge',
    erro_objetivo: 'Selecione o objetivo principal da conversa',
    erro_descricao: 'Descreva seu negócio (campo obrigatório)',
    avancado_titulo: '⚙️ Modo avançado (edição manual)',
    avancado_bloqueado_titulo: 'Modo avançado liberado sob solicitação',
    avancado_bloqueado_desc: 'A edição manual de persona, base de conhecimento e funil exige conhecimento de prompt engineering. Para evitar configurações que prejudiquem o desempenho da sua secretária, esse modo é liberado mediante solicitação ao suporte — nossa equipe valida sua configuração antes da liberação.',
    avancado_btn_solicitar: 'Solicitar acesso ao modo avançado',
    avancado_email_assunto: 'Solicitação de acesso — Modo avançado IA',
    avancado_email_corpo: 'Olá, gostaria de liberar o modo avançado de configuração da Concierge IA para a minha conta. Email da conta: ',
    label_persona: 'Persona / instruções de tom',
    label_conhecimento: 'Base de conhecimento — o que sua IA sabe sobre o negócio',
    label_funil: 'Funil de qualificação — o que sua IA precisa descobrir',
    label_delay: 'Delay antes de responder ({s}s)',
    delay_recomendado: 'Recomendado: 8s (geral), 12–15s (saúde/jurídico), 0s para resposta imediata.',
    label_pausa_horas: 'Pausa ao assumir controle (horas)',
    btn_salvar_avancado: 'Salvar configuração técnica',
    btn_salvando: 'Salvando...',
    btn_diagnostico: 'Diagnóstico',
    diag_titulo: 'Diagnóstico',
    diag_ok: 'Tudo certo — IA deveria estar respondendo.',
    diag_ultimas: 'Últimas {n} mensagens registradas',
    teste_titulo: 'Testar IA',
    teste_desc: 'Simula uma pergunta usando a persona e base de conhecimento atuais (sem enviar pelo WhatsApp).',
    placeholder_teste: 'Ex: Qual o horário de atendimento?',
    btn_testar: 'Testar',
    btn_testando: 'Testando...',
    resposta_vazia: '(resposta vazia)',
    tipo_saude_nome: 'Saúde & Clínicas',
    tipo_saude_desc: 'Médicos, dentistas, clínicas',
    tipo_beleza_nome: 'Beleza & Estética',
    tipo_beleza_desc: 'Salão, barbearia, estética',
    tipo_alimentacao_nome: 'Alimentação',
    tipo_alimentacao_desc: 'Restaurante, delivery, café',
    tipo_educacao_nome: 'Educação & Cursos',
    tipo_educacao_desc: 'Escola, cursos, capacitações',
    tipo_comercio_nome: 'Comércio',
    tipo_comercio_desc: 'Loja, varejo, e-commerce',
    tipo_servicos_nome: 'Serviços',
    tipo_servicos_desc: 'Manutenção, consultoria, reformas',
    tipo_imoveis_nome: 'Imóveis',
    tipo_imoveis_desc: 'Imobiliária, aluguel, venda',
    tipo_juridico_nome: 'Jurídico & Financeiro',
    tipo_juridico_desc: 'Advocacia, contabilidade, seguros',
    tipo_outro_nome: 'Outro',
    tipo_outro_desc: 'Meu negócio não está listado',
    estilo_humana_nome: 'Humana',
    estilo_humana_desc: 'Empática, próxima, usa o nome do cliente',
    estilo_direta_nome: 'Direta',
    estilo_direta_desc: 'Vai ao ponto, respostas curtas e objetivas',
    estilo_persuasiva_nome: 'Persuasiva',
    estilo_persuasiva_desc: 'Foca em converter, destaca benefícios e cria urgência',
    estilo_profissional_nome: 'Profissional',
    estilo_profissional_desc: 'Tom corporativo, linguagem estruturada e formal',
    estilo_descontraida_nome: 'Descontraída',
    estilo_descontraida_desc: 'Casual, amigável, usa emojis com naturalidade',
    label_tratamento: 'Como falar com o cliente',
    tratamento_voce_nome: 'Você',
    tratamento_voce_desc: 'Tratamento direto, mais próximo',
    tratamento_senhor_nome: 'Senhor / Senhora',
    tratamento_senhor_desc: 'Tratamento formal e respeitoso',
    opcao_contato_whatsapp: 'WhatsApp',
    opcao_contato_telefone: 'Telefone',
    opcao_contato_site: 'Site',
    opcao_contato_presencial: 'Presencialmente',
    opcao_contato_email: 'E-mail',
    opcao_contato_app: 'App',
    opcao_pag_dinheiro: 'Dinheiro',
    opcao_pag_credito: 'Cartão de crédito',
    opcao_pag_debito: 'Cartão de débito',
    opcao_pag_pix: 'PIX',
    opcao_pag_boleto: 'Boleto',
    opcao_pag_convenio: 'Plano/Convênio',
    opcao_pag_parcelamento: 'Parcelamento próprio',
    notif_titulo: 'Notificação automática de paciente',
    notif_desc: 'Quando a IA coletar os dados configurados abaixo, envia automaticamente uma mensagem para o número informado (ex: linha de agendamentos, secretaria, vendas).',
    notif_ativar: 'Ativar notificação automática',
    notif_telefone: 'Número que receberá as notificações',
    notif_telefone_ph: 'Ex: 5511999999999',
    notif_telefone_ajuda: 'Inclua DDD e DDI (55 para Brasil). Apenas números.',
    notif_campos: 'Dados que devem ser coletados antes de notificar',
    notif_campo_nome: 'Nome completo',
    notif_campo_cpf: 'CPF',
    notif_campo_email: 'E-mail',
    notif_campo_contato: 'Telefone de contato',
    notif_campo_data: 'Data de agendamento',
    notif_campo_horario: 'Horário de agendamento',
    btn_salvar_notif: 'Salvar notificação',
    agenda_titulo: 'Integração com Agenda',
    agenda_desc: 'Quando a IA confirmar um agendamento com o cliente (data e horário definidos), cria automaticamente o evento no seu calendário.',
    agenda_provedor: 'Provedor de calendário',
    agenda_prov_nenhum: 'Nenhum',
    agenda_selecione_provedor: 'Selecione um provedor para configurar a integração.',
    agenda_google_desc: 'Autorize o acesso à sua conta Google para criar eventos automaticamente. É necessário ter GOOGLE_CLIENT_ID configurado no servidor.',
    agenda_google_autorizar: 'Autorizar com Google',
    agenda_google_conectado: 'Google Calendar conectado com sucesso!',
    agenda_google_desconectado: 'Google Calendar desconectado',
    agenda_google_conectado_badge: 'Conta Google conectada',
    agenda_google_desconectar: 'Desconectar',
    agenda_google_erro_auth: 'Erro ao iniciar autorização Google',
    agenda_google_calendar_id: 'ID do calendário',
    agenda_google_calendar_id_ajuda: 'Use "primary" para o calendário principal ou o ID de um calendário específico.',
    agenda_icloud_desc: 'Informe suas credenciais Apple para criar eventos via CalDAV. Por segurança, a Apple exige uma senha específica de app — sua senha normal não funciona aqui.',
    agenda_icloud_passos_titulo: 'Como conectar (leva 1 minuto):',
    agenda_icloud_passo1: 'Acesse appleid.apple.com e faça login com seu Apple ID.',
    agenda_icloud_passo2: 'Em "Segurança", abra "Senhas de apps específicas" e clique em "Gerar uma senha". Dê o nome "RIIA" e copie a senha exibida.',
    agenda_icloud_passo3: 'Cole seu Apple ID e a senha gerada nos campos abaixo. Deixe o campo da URL em branco.',
    agenda_icloud_passo4: 'Clique em "Testar conexão" — a URL do seu calendário é detectada automaticamente.',
    agenda_icloud_username: 'Apple ID (e-mail)',
    agenda_icloud_password: 'Senha específica de app',
    agenda_icloud_password_ph: 'Gerada em appleid.apple.com',
    agenda_icloud_url: 'URL do calendário CalDAV (opcional)',
    agenda_icloud_url_ajuda: 'Deixe em branco — a URL é detectada automaticamente ao testar a conexão.',
    agenda_icloud_url_auto: 'Detectada automaticamente',
    agenda_dias: 'Dias disponíveis para agendamento',
    agenda_dom: 'Dom', agenda_seg: 'Seg', agenda_ter: 'Ter',
    agenda_qua: 'Qua', agenda_qui: 'Qui', agenda_sex: 'Sex', agenda_sab: 'Sáb',
    agenda_hora_inicio: 'Horário de início',
    agenda_hora_fim: 'Horário de fim',
    agenda_duracao: 'Duração padrão',
    agenda_timezone: 'Fuso horário',
    agenda_ativar: 'Ativar criação automática de eventos',
    agenda_confirmacao_ativar: 'Esta instância envia confirmações e lembretes da agenda',
    agenda_confirmacao_ajuda: 'Desmarque em instâncias secundárias que compartilham a mesma agenda (ex.: mesmo Simples Dental) para evitar mensagens duplicadas ao paciente. Mantenha marcada em apenas uma instância por agenda.',
    credencial_revelar: 'Revelar valor salvo',
    credencial_revelando: 'Revelando...',
    credencial_ocultar: 'Ocultar',
    credencial_copiar: 'Copiar',
    credencial_copiada: 'Credencial copiada',
    credencial_copiar_falhou: 'Não foi possível copiar',
    credencial_vazia: '(nunca preenchido)',
    credencial_aviso: 'Valor sigiloso. Este acesso fica registrado na trilha de auditoria.',
    lembretes_titulo: 'Lembretes automáticos',
    lembretes_ajuda: 'Defina com quanta antecedência avisar o cliente. Cada linha gera uma mensagem. Sem nenhuma linha, seguem valendo os lembretes padrão (1 dia e 2 horas antes).',
    lembretes_add: 'Adicionar lembrete',
    lembretes_antes: 'antes',
    lembretes_dias: 'dias',
    lembretes_horas: 'horas',
    lembretes_confirma: 'Pedir confirmação de presença',
    lembretes_confirma_ajuda: 'Marque nas antecedências em que a IA deve perguntar "posso confirmar sua presença?". As demais são apenas aviso. Em Google Agenda e iCloud a resposta fica registrada aqui, porque esses calendários não têm campo de confirmação.',
    lembretes_janela: 'Janela de envio — nenhum lembrete sai fora deste horário, no fuso da agenda.',
    lembretes_conflito: 'Esta instância está marcada para NÃO enviar confirmações/lembretes (opção acima). Com antecedências configuradas aqui, o envio antigo também deixa de cobrir esta instância — resultado: nenhum lembrete sai. Marque a opção acima, ou configure as antecedências na outra instância que compartilha esta agenda.',
    lembretes_diag: 'Diagnóstico dos lembretes',
    lembretes_diag_rodando: 'Verificando…',
    diag_timeout: 'O diagnóstico demorou demais para responder. Isso é tempo, não necessariamente defeito: o sistema da sua empresa pode estar lento agora. Tente de novo em alguns minutos.',
    diag_rede: 'Não foi possível falar com o servidor para rodar o diagnóstico. Confira sua conexão e tente de novo.',
    lembretes_diag_erro: 'Falha ao rodar o diagnóstico dos lembretes',
    reativacao_titulo: "Reativar clientes que pararam de voltar",
    reativacao_desc: "Uma vez por hora, a RIIA lê a agenda do seu sistema, encontra quem não aparece há um tempo e manda UMA mensagem. Quem responder cai na concierge, que marca o horário. Desligado por padrão — nada é enviado enquanto você não marcar aqui.",
    reativacao_dias_label: "Sem voltar há",
    reativacao_dias_hint: "dias ou mais (de 7 a 60 — o limite vem do alcance da agenda do seu sistema)",
    reativacao_texto_label: "Mensagem (opcional)",
    reativacao_texto_ph: "Oi {nome}! Faz um tempinho que você não aparece por aqui 😊 Quer que eu veja um horário para você esta semana?",
    reativacao_texto_hint: 'Use {nome} para o primeiro nome do cliente. Escreva UMA MENSAGEM POR LINHA para variar — a cada envio sai uma delas, e nunca duas iguais seguidas. Em branco, usamos 5 variações padrão.',
    reativacao_diag: "Diagnóstico da reativação",
    reativacao_diag_rodando: "Conferindo...",
    reativacao_diag_erro: "Falha ao rodar o diagnóstico da reativação",
    reativacao_previa: "Quem sairia neste ciclo:",
    pos_atend_titulo: 'Agradecer após o atendimento',
    pos_atend_desc: 'Depois da visita, a concierge manda uma mensagem de agradecimento — e, se você quiser, pede uma avaliação. A resposta cai aqui na conversa normalmente.',
    pos_atend_horas_label: 'Enviar',
    pos_atend_horas_hint: 'horas após o início do atendimento (1 a 48)',
    pos_atend_texto_label: 'Mensagem (opcional)',
    pos_atend_texto_ph: 'Oi {nome}! Passando para agradecer a sua visita {quando} 😊',
    pos_atend_texto_hint: 'Use {nome} para o primeiro nome do cliente e {quando} para o dia da visita (vira “de hoje”, “de ontem” ou o dia da semana — o envio costuma cair no dia seguinte). Escreva UMA MENSAGEM POR LINHA para variar — a cada envio sai uma delas, e nunca duas iguais seguidas. Em branco, usamos 5 variações padrão.',
    pos_atend_avaliacao: 'Pedir avaliação na mesma mensagem',
    pos_atend_link_ph: 'https://g.page/sua-empresa/review',
    pos_atend_link_hint: 'Link da avaliação (Google, Instagram…). Sem link, pedimos a opinião aqui pelo WhatsApp.',
    pos_atend_diag: 'Diagnóstico do pós-atendimento',
    pos_atend_diag_rodando: 'Verificando…',
    pos_atend_diag_erro: 'Não foi possível rodar o diagnóstico',
    pos_atend_previa: 'Quem sairia neste ciclo:',
    pos_atend_com_avaliacao: 'com pedido de avaliação',
    pos_atend_avaliacao_hint: 'O pedido de avaliação sai só na PRIMEIRA mensagem de pós-atendimento de cada cliente. Quem já recebeu continua sendo agradecido, mas sem o pedido nem o link.',
    espera_titulo: 'Avisar quando abrir vaga (lista de espera)',
    espera_desc: 'Quando o cliente pede um dia que está cheio, a concierge guarda o pedido. Se uma vaga abrir naquele dia, ela avisa e oferece — sem prometer, porque a vaga pode ser pega por outra pessoa.',
    espera_texto_label: 'Mensagem (opcional)',
    espera_texto_ph: 'Oi {nome}! Abriu um horário {quando} 😊 Quer que eu marque para você?',
    espera_texto_hint: 'Use {nome} para o primeiro nome e {quando} para o horário que vagou.',
    espera_diag: 'Diagnóstico da lista de espera',
    espera_diag_rodando: 'Verificando…',
    espera_diag_erro: 'Não foi possível rodar o diagnóstico',
    espera_previa: 'Quem está na fila:',
    reativacao_sem_voltar: "sem voltar há {dias} dias",
    lembretes_janela_de: 'Enviar a partir de',
    lembretes_janela_ate: 'até',
    lembretes_remover: 'Remover',
    btn_salvar_agenda: 'Salvar agenda',
    agenda_testar: 'Testar conexão',
    agenda_testando: 'Testando...',
    agenda_toast_salvo: 'Configuração de agenda salva!',
    confirmar_desativar_integracao: 'Desativar esta integração? A concierge deixará de consultar horários e agendar por ela. As credenciais salvas serão removidas.',
    agenda_toast_conexao_ok: 'Conexão com o calendário OK!',
    agenda_toast_conexao_erro: 'Falha na conexão com o calendário',
  },

  conversas: {
    titulo: 'Conversas',
    subtitulo: 'Histórico de conversas e respostas automáticas via IA. A IA responde independentemente desta tela — basta que a configuração esteja salva e ativada para cada instância.',
    btn_debug: '🔍 Debug',
    btn_atualizar: 'Atualizar',
    debug_titulo: 'Diagnóstico do Webhook',
    debug_config_titulo: 'Configuração atual na Evolution',
    debug_config_select: 'Selecione uma aba de instância para ver a config do webhook dela.',
    debug_ultimos: 'Últimos {n} webhooks recebidos (mais recente primeiro)',
    debug_sem_webhook: '⚠ Nenhum webhook recebido desde o último restart do servidor. Se você acabou de enviar uma mensagem e nada aparece aqui, a Evolution NÃO está conseguindo entregar os webhooks no backend (URL errada, instância sem webhook configurado, ou erro de rede).',
    abas_todas: 'Todas',
    todas_instancias: 'Todas as instâncias',
    aba_instancia: 'Instância: {nome}',
    busca_placeholder: 'Buscar nome ou telefone',
    sem_conversas: 'Nenhuma conversa ainda.',
    webhook_aviso_titulo: '⚠ Sem mensagens nesta instância?',
    webhook_aviso_texto: 'O webhook pode não estar configurado na Evolution API para "{instancia}". Clique abaixo para registrá-lo automaticamente.',
    btn_configurar_webhook: 'Configurar webhook agora',
    badge_humano: 'Humano',
    badge_ia_ativa: 'IA ativa',
    badge_pendente: 'Aguardando equipe',
    badge_insatisfeito: 'Cliente insatisfeito',
    badge_followup: 'Follow-up enviado',
    badge_admin_grupo: 'Admin do grupo',
    badge_ia_no_grupo: 'IA ativa no grupo',
    btn_ativar_ia_grupo: 'Permitir IA no grupo',
    btn_desativar_ia_grupo: 'Desativar IA do grupo',
    toast_ia_grupo_ativada: 'IA autorizada a responder neste grupo',
    toast_ia_grupo_desativada: 'IA desativada neste grupo',
    toast_err_ia_grupo: 'Erro ao alterar autorização da IA no grupo',
    grupo_label: 'Grupo de WhatsApp',
    qualif_todas: 'Todas',
    qualif_agendados: 'Agendados',
    qualif_aguardando: 'Aguardando',
    selecione_conversa: 'Selecione uma conversa',
    btn_voltar: '← Voltar',
    btn_assumir: 'Assumir',
    btn_retomar_ia: 'Retomar IA',
    sem_mensagens: 'Sem mensagens ainda',
    placeholder_mensagem: 'Digite uma mensagem... (Enter envia, Shift+Enter quebra linha)',
    placeholder_legenda: 'Legenda (opcional)...',
    btn_enviar: 'Enviar',
    btn_enviando: 'Enviando...',
    aviso_pausar: 'Ao enviar manualmente, a IA é pausada nessa conversa pelo tempo configurado.',
    toast_midia_erro: 'Não foi possível carregar a mídia',
    toast_midia_expirada: 'Mídia indisponível — arquivos do WhatsApp expiram após alguns dias',
    toast_erro_conversas: 'Erro ao carregar conversas',
    toast_erro_msgs: 'Erro ao carregar mensagens',
    toast_pausada: 'IA pausada por {horas}h',
    toast_retomada: 'IA retomada',
    toast_err_pausar: 'Erro ao pausar IA',
    toast_err_retomar: 'Erro ao retomar IA',
    btn_reativar_ia: 'Reativar IA',
    toast_reativada: 'IA reativada nesta conversa',
    toast_err_reativar: 'Erro ao reativar IA',
    toast_err_enviar: 'Erro ao enviar',
    toast_webhook_ok: 'Webhook configurado: {url}',
    toast_webhook_err: 'Erro ao configurar webhook',
    anexo_baixar: 'Baixar',
    anexo_carregando: 'Carregando...',
    audio_ouvir: 'Ouvir mensagem de voz',
    arquivo_grande: 'Arquivo muito grande (máx 16 MB)',
  },

  perfil: {
    titulo: 'Perfil da empresa',
    subtitulo: 'Personalize a identidade visual e veja sua assinatura.',
    carregando: 'Carregando...',
    sua_assinatura: 'Sua assinatura',
    plano_label: 'Plano {nome}',
    periodo_anual: 'Anual',
    periodo_mensal: 'Mensal',
    vencimento: 'Vencimento',
    dias_restantes: '{n} dias restantes',
    status_vencida: '⚠️ Assinatura vencida — renove para continuar',
    status_vencendo: '⚠️ Vence em breve — considere renovar',
    preview_titulo: 'Preview do painel',
    preview_empresa: 'Sua empresa',
    preview_segmento: 'Segmento',
    stat_plano: 'Plano',
    stat_status: 'Status',
    stat_campanhas: 'Campanhas',
    stat_contatos: 'Contatos',
    form_titulo: 'Informações da empresa',
    label_nome_empresa: 'Nome da empresa',
    placeholder_nome_empresa: 'Ex: Clínica Bem Estar',
    label_segmento: 'Segmento',
    segmento_placeholder: 'Selecione...',
    label_logo_url: 'URL do logo',
    placeholder_logo_url: 'https://sua-empresa.com/logo.png',
    logo_help: 'Use uma URL pública da imagem',
    label_cor: 'Cor principal do painel',
    btn_salvar: 'Salvar perfil',
    btn_salvando: 'Salvando...',
    toast_salvo: 'Perfil atualizado!',
    toast_erro: 'Erro ao salvar',
    seg_clinica: 'Clínica / Saúde',
    seg_imobiliaria: 'Imobiliária',
    seg_educacao: 'Educação',
    seg_varejo: 'Varejo / E-commerce',
    seg_restaurante: 'Restaurante / Alimentação',
    seg_beleza: 'Beleza / Estética',
    seg_advocacia: 'Advocacia / Jurídico',
    seg_contabilidade: 'Contabilidade / Financeiro',
    seg_tecnologia: 'Tecnologia',
    seg_outro: 'Outro',
  },
};

export default pt;
